module.exports = __webpack_public_path__ + "static/media/shiptoship.59b59691.png";